import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AdministrativeOptionsEnum } from 'src/app/Enums/AdministrativeOptionsEnum';
import { AdministrativeService } from 'src/app/services/administrative/administrative.service';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportInfoComponent implements OnInit {

  public supportEmail: string = "";

  constructor(
    public dialogRef: MatDialogRef<SupportInfoComponent>,
    public adminService: AdministrativeService,
    private appConfig: AppConfigService
  ) { }

  async ngOnInit() {
    var ret = await this.adminService.getConfigurationValue(AdministrativeOptionsEnum.EMAIL_SUPORTE_FLIPE_ON);
    this.supportEmail = ret == "" ? this.appConfig.supportEmail : ret;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
